<template>
  <template v-if="video?.video_config?.resolution?.length > 1">
    <div class="mt-2 w-full">
      <button @click="open = !open"
        class="w-full font-mono px-1 text-[10px] uppercase mb-[3px] hover:bg-flyingeye-light"
        :class="{ 'bg-g0-dark': !open, 'bg-flyingeye-light': open }">
        {{ $e("Résolution") }}
      </button>
      <div class="flex flex-col" v-if="open">
        <template v-for="resolution in video?.video_config.resolution" :key="resolution">
          <button @click="edit_resolution(Object.keys(resolution)[0])"
            class="bg-g0-dark font-mono px-1 text-[10px] uppercase mb-[3px] hover:bg-flyingeye-light" :class="{
              '!bg-flyingeye': config?.camera?.status?.video_quality == Object.keys(resolution)[0]
            }">
            {{ resolution[Object.keys(resolution)[0]] }}
          </button>
        </template>
      </div>
    </div>
  </template>

</template>
<script>
import { ref } from "vue";
import API from "@/utils/API";

export default {
  name: "Resolution",
  props: {
    config: Object,
    video: Object,
  },
  setup() {
    return {
      open: ref(false),
    };
  },

  methods: {
    async edit_resolution(resolution) {
      let data = await API.put("videoquality", {
        DvvId: this.video.dvv_id,
        QuaId: resolution
      });

      this.$root.msg_replie[data.command] = {
        id: data.command,
        name: this.$e("Changement de résolution"),
      };
    },
  },
};
</script>
